window.initProductSelects = function(container = document) {
    const wrappers = container.querySelectorAll('.product-select:not([data-select-initialized])');

    wrappers.forEach((wrapper, index) => {
        let listElement = wrapper.querySelector('.product-select__list');
        let mainElement = wrapper.querySelector('.product-select__main');

        wrapper.dataset.selectInitialized = '1';
        wrapper.addEventListener('click', function () {
            listElement.classList.toggle('open');
        });

        const listItems = listElement.querySelectorAll('.product-select__list-item');
        const activeElement = mainElement.querySelector('.product-select__active');
    });
}

// Инициализировать отображение товаров при загрузке страницы
function initializeProductView() {
    const savedView = localStorage.getItem('productViewType') || 'bigItems';
    const viewElement = document.getElementById(savedView);
    
    if (viewElement) {
        viewElement.click();
    }
}

document.querySelectorAll('.view-item').forEach(item => {
    item.addEventListener('click', () => {
        document.querySelectorAll('.view-item').forEach(item => {
            item.classList.remove('active-item');
        });
        item.classList.add('active-item');

        // Сохраняем выбранный вид в localStorage
        localStorage.setItem('productViewType', item.id);

        const bigItems = document.getElementById('bigItems');
        const smallItems = document.getElementById('smallItems');
        const rowItems = document.getElementById('rowItems');

        const contentGrid = document.querySelector('.content-grid');
        const miniGrid = document.querySelector('#small-items-grid');
        const contentRow = document.querySelector('.content-row');

        if (bigItems.classList.contains('active-item')) {
            contentGrid.style.display = 'grid';
            miniGrid.style.display ='none';
            contentRow.style.display = 'none';
        } else if (smallItems.classList.contains('active-item')) {
            contentRow.style.display = 'none';
            contentGrid.style.display = 'none';
            miniGrid.style.display = 'grid';
        } else if (rowItems.classList.contains('active-item')) {
            contentGrid.style.display = 'none';
            miniGrid.style.display = 'none';
            contentRow.style.display = 'flex';
        }
    });
});

// Инициализировать при загрузке DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductView);
} else {
    initializeProductView();
}

window.filterItems = function (inputElement, listId) {
  const searchTerm = inputElement.value.trim();
  const list = inputElement.closest('.filter-item__content').querySelector(listId);
  const items = list.querySelectorAll('.filter-item__item');
  
  // Создаем регулярное выражение
  const regex = searchTerm ? 
    new RegExp(searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : 
    null;
  
  items.forEach(item => {
    const nameElement = item.querySelector('.filter-item__name');
    if (nameElement) {
      const text = nameElement.textContent || '';
      item.style.display = !regex || regex.test(text) ? '' : 'none';
    }
  });
  
  // Показываем сообщение если ничего не найдено
  showNoResultsMessage(list, items, searchTerm);
}

function showNoResultsMessage(list, items, searchTerm) {
  // Удаляем старое сообщение
  const oldMessage = list.querySelector('.filter-no-results');
  if (oldMessage) oldMessage.remove();
  
  // Проверяем видимые элементы
  const visibleItems = Array.from(items).filter(item => item.style.display !== 'none');
  
  if (searchTerm && visibleItems.length === 0) {
    const noResults = document.createElement('div');
    noResults.className = 'filter-no-results';
    noResults.textContent = 'Ничего не найдено';
    noResults.style.cssText = `
      padding: 8px 12px;
      color: #999;
      font-style: italic;
    `;
    list.appendChild(noResults);
  }
}

let filterBtn = document.querySelector('.filter-btn');
if (filterBtn) {
    filterBtn.addEventListener('click', function () {
        document.querySelector('.mobile-filter').classList.add('open');
        document.body.classList.add('shaded');
    });
}
let closeBtn = document.querySelector('.btn-close');
if (closeBtn) {
    closeBtn.addEventListener('click', function () {
        document.querySelector('.mobile-filter').classList.remove('open');
        document.body.classList.remove('shaded');
    });
}
let removeBtn = document.querySelector('.btn-remove');
if (removeBtn) {
    removeBtn.addEventListener('click', function () {
        const form = document.getElementById('mobile-filter-form');
        if (form) {
            window.location.href = form.action.split('?')[0];
        }
    });
}

// Делает ширину названий фильтров по ширине самой длинной строки, чтобы схлопнуть пустоту в конце блока.
// Было:
// |Трансформаторные    |
// |масла               |
// Стало:
// |Трансформаторные|
// |масла           |
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.filter-item__name').forEach(function (el) {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        if (el.scrollHeight <= lineHeight * 1.2) return;

        const range = document.createRange();
        range.selectNodeContents(el);
        const rects = range.getClientRects();
        if (rects.length === 0) return;

        const maxWidth = Math.max(...Array.from(rects).map(function (r) { return r.width; }));
        el.style.width = Math.ceil(maxWidth) + 'px';
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const fieldElements = document.querySelectorAll('.filter-select__field');

    fieldElements.forEach(field => {
        const list = field.nextElementSibling;
        const listItems = list.querySelectorAll('.filter-select__list-item');

        field.addEventListener('click', function () {
            list.classList.toggle('open');
        });

        listItems.forEach(item => {
            item.addEventListener('click', function () {
                const activeElement = field.parentElement.querySelector('.filter-select__active');
                activeElement.textContent = item.textContent;
                list.classList.remove('open');
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
   window.initProductSelects()
});

document.addEventListener('DOMContentLoaded', function () {
    const sortFieldMain = document.querySelector('.sort-field__main');
    const sortFieldList = document.querySelector('.sort-field__list');
    const sortArrow = document.querySelector('.sort-arrow');
    const sortFieldItems = document.querySelectorAll('.sort-field__list-item');
    const sortFieldName = document.querySelector('.sort-field__name');

    if (sortFieldMain) {
        sortFieldMain.addEventListener('click', function () {
            sortFieldList.classList.toggle('open');
            sortArrow.style.transform = sortFieldList.classList.contains('open') ? 'rotate(180deg)' : 'rotate(0deg)';
        });
    }

    sortFieldItems.forEach(item => {
        item.addEventListener('click', function () {
            sortFieldName.textContent = item.textContent;
            sortFieldList.classList.remove('open');
            sortArrow.style.transform = 'rotate(0deg)';
        });
    });
});

let mobileSortBtn = document.querySelector('.m__sort-field .sort-field__main');
if (mobileSortBtn) {
    mobileSortBtn.addEventListener('click', function () {
        document.querySelector('.mobile-sort').classList.add('open');
        document.body.classList.add('hidden');
    });
}

const mobileSortItems = document.querySelectorAll('.mobile-sort__item');
mobileSortItems.forEach(item => {
    item.addEventListener('click', function() {
        mobileSortItems.forEach(otherItem => {
            otherItem.classList.remove('selected');
        });
        item.classList.add('selected');
    });
});

window.incrementQuantity = function(klass) {
    const inputElements = document.querySelectorAll(klass);
    // The stepUp() method increments the value by the step attribute value (default 1)
    inputElements.forEach(element => {
        element.stepUp(); 
    });
}

window.decrementQuantity = function(klass) {
    console.log(klass)
    const inputElements = document.querySelectorAll(klass);
    // The stepDown() method decrements the value by the step attribute value (default 1)
    inputElements.forEach(element => {
        element.stepDown(); 
    });
}
